var AT_AjaxSearch = {
    ajaxProductItems: function(e, a, h) {
        new Array;
        var p = e.val();
        jQuery.ajax({
            type: "GET",
            data: {
                q: "*" + p + "*",
                type: "product",
                view: "json"
            },
            dataType: "json",
            url: "/search",
            complete: function() {
                jQuery(".searchbox #circularG").addClass("hide")
            },
            success: function(e) {
                if (h.html(" "), 0 < e.length) {
                    for (var a = 0; a < e.length; a++) {
                        var r = e[a],
                            s = r.title,
                            t = r.price,
                            t_r = t.replace('£', ''),
                            t_m = Number(t_r) * 1.2,
                            t_m_f = Shopify.formatMoney(t_m.toFixed(2), _bc_config.money_format),
                            l = r.handle,
                            c = r.featured_image,
                            i = r.has_compare_price ? '<span class="price-compare">' + r.compare_price + "</span>" : "",
                            u = r.has_compare_price ? "price-sale" : "price",
                            n = r.available ? "" : " sold-out ",
                            o = (t = r.available ? r.price : r.out_stock_nofication, '<li class="result-item just-added" style="display:none;"><a class="search-item-img" href="' + l + '"><img style="max-width: 60px; float: left;" src="' + c + '" /></a><a class="search-item-title" href="' + l + '">' + s.replace(new RegExp("(" + p + ")", "gi"), '<span class="marked">$1</span>') + "</a>" + i + '<span class="' + u + n + '">' + t_m_f + "</span></li>");
                        h.append(o), setTimeout(function() {
                            h.children("li.result-item.just-added").removeClass("just-added").slideDown(600)
                        }, 300)
                    }
                    $("#result-ajax-search .search-results li").length && ($("#result-ajax-search").show(), currenciesCallbackSpecial("#result-ajax-search span.money"))
                } else h.html('<li class="result-item"><p>No result found for your search.</p></li>'), $("#result-ajax-search").show()
            }
        })
    },
    ajaxSearch: function(e) {
        var l, a, c = this,
            r = 0 < e.search_input.length ? e.search_input : "#bc-product-search",
            i = 0 < e.result_wrapper.length ? e.result_wrapper : "#result-ajax-search",
            u = 0 < e.result_element.length ? e.result_element : ".search-results";
        jQuery(document).delegate(r, "keyup", function(e) {
            var a = jQuery(this).val(),
                r = jQuery(this),
                s = jQuery(i),
                t = s.children(u);
            l && clearTimeout(l), l = setTimeout(function() {
                2 <= a.length ? (jQuery(this).removeClass("error warning valid").addClass("valid"), jQuery(".searchbox #circularG").removeClass("hide"), c.ajaxProductItems(r, s, t)) : (jQuery(this).removeClass("error warning valid").addClass("error"), t.html("<li><p>You must enter at least 2 characters.</p></li>"))
            }, 300)
        }), jQuery(document).delegate("#search.navbar-form", "blur", function(e) {
            jQuery(this);
            a && clearTimeout(a), a = setTimeout(function() {
                jQuery("#result-ajax-search").hide()
            }, 1500)
        })
    },
    init: function(e) {
        this.ajaxSearch(e)
    }
};
jQuery(document).ready(function(e) {
    AT_AjaxSearch.init({
        search_input: "#bc-product-search",
        result_wrapper: "#result-ajax-search",
        result_element: ".search-results",
        strictly_mode: 0
    })
});